/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

enum SWIMLANE_GRAPHICS {
	SWIMLANE_AREA = 'swimlane',
	SWIMLANE_LINE = 'swimlaneLine',
	SWIMLANE_TEXT_BACKGROUND = 'swimlaneTextBackground',
	SWIMLANE_LINE_CIRCLE = 'swimlaneLineCircle',
	TEXTURE_SWIMLANE_DRAG_HANDLE = 'swimlane-drag-handle.png',
}

const SWIMLANE_LABEL_STYLE = {
	fontSize: 14,
	fill: 0xffffff,
	fontFamily: 'Roboto',
};

enum SWIMLANE_LABEL_SETTINGS {
	BACKGROUND_COLOR = '#000000',
	BACKGROUND_ALPHA = 0.67,
	BACKGROUND_TOP_PADDING = 6,
	BACKGROUND_BOTTOM_PADDING = 6,
	BACKGROUND_LEFT_PADDING = 12,
	BACKGROUND_RIGHT_PADDING = 12,
	BACKGROUND_RADIUS = 6,
	LABEL_MAX_LENGTH = 35,
	LABEL_STICKINESS_THRESHOLD = 93,
	LABEL_TOP_PADDING = 3,
	AREA_DASH_LENGTH = 2,
	LINE_EDIT_COLOR = '#0496ff',
	LINE_NORMAL_COLOR = '#959DA5',
	LINE_HIT_AREA_HEIGHT = 15,
}

enum SWIMLANE_SPOT {
	TOP = 'top',
	BOTTOM = 'bottom',
}

export { SWIMLANE_GRAPHICS, SWIMLANE_LABEL_STYLE, SWIMLANE_LABEL_SETTINGS, SWIMLANE_SPOT };
